import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { CoreModule } from '../core.module';
import { UserService } from './data/user.service';
import { IOrder, IUser } from '../../types/datatypes';
import { AnalyticsService } from './analytics.service';
import { LogsService } from './logs.service';
import { OrderService } from './data/order.service';

@Injectable({
	providedIn: CoreModule,
})

export class CheckoutService {
	private user: IUser;

	constructor(
		private us: UserService,
		private analyticsService: AnalyticsService,
		private logsService: LogsService,
		private os: OrderService,
	) {
		this.us.fetchUser().then((data: any) => {
			this.user = data;
		});
	}

	handleSuccess(order: IOrder, source: 'Stripe' | 'PayPal', amount: number) {
		this.gaEvent(order, amount);
		this.log(source, order._id, 'success');

		return { soldOut: false };
	}

	handleCancelled(order, source) {
		const errorText = [`The ${source} transaction was cancelled!`];
		this.log(source, order, 'cancelled');

		return { errorText };
	}

	parseUnknownPaypalError(error) {
		let message = 'An unknown error occurred.';
		if (!error) {
			return message;
		}

		if (typeof error === 'object') {
			// If it's an object, construct a message from its properties.
			if (typeof error.message !== 'undefined') {
				message = error.message;
			}
			if (typeof error.name !== 'undefined') {
				message += ` (${error.name})`;
			}
			if (typeof error.code !== 'undefined') {
				message += ` (#${error.code})`;
			}
		} else if (typeof error === 'string') {
			// If it's a string, set that as the error message.
			message = error;
		}

		return message;
	}

	handleSoldOutCart(event, order, source) {
		const invalidFeatures = order.items.filter(({ itemId }) => event.data.includes(itemId));
		const invalidFeatureMeta = {};
		invalidFeatures.forEach((feature) => {
			const { item: { _book, pubDate, _id } } = feature;
			invalidFeatureMeta[_id] = `
				${_book.title} by ${_book.author} on ${moment(pubDate, 'YYYYMMDD').format('MMMM Do, YYYY')}.
			`;
		});

		const errorText = ['The dates you selected for the following features are no longer available.'
+ ' Please select a new one.'];
		const errorExtra = invalidFeatureMeta;
		const soldOut = true;

		this.log(source, order._id, 'error', 'sold_out_cart', 'Sold Out Cart Error');

		return { errorText, errorExtra, soldOut };
	}

	handleAdvertInventoryConflict(event, order, source) {
		// There is an oversell conflict for a site advert
		const { text, title } = this.os.parseAdvertInventoryConflictError(event.advertsWithInventoryConflict, order);
		const errorText = [text];
		const errorTitle = title;

		this.log(source, order._id, 'error', 'advert_inventory_conflict', 'Advert Inventory Conflict Error', event);
		return { errorText, errorTitle };
	}

	handleSoldOut(order, source) {
		const errorText = ['The date you selected is no longer available'];
		const soldOut = true;
		this.log(source, order._id, 'error', 'sold_out', 'Soldout Error');

		return { errorText, soldOut };
	}

	gaEvent(order: IOrder, amount) {
		const userEmail = this.user ? this.user.username : order.purchaserInfo.email;

		const gaItems = this.analyticsService.generateCartItemsEcommerceObjects(order.items);

		this.analyticsService.trackPurchase(userEmail, amount, gaItems);
	}

	log(type: 'Stripe' | 'PayPal', orderId: any, status: 'error' | 'cancelled' | 'success', errorCode = null, message = null, event = null) {
		this.logsService.postLog({
			type,
			message: JSON.stringify({
				orderId,
				status,
				message,
				errorCode,
				event,
			}),
		});
	}
}
